import player from 'lottie-web'
import { LottieComponent, provideLottieOptions } from 'ngx-lottie'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { TableHeadColumnComponent } from './table-head-column/table-head-column.component'
import { TableComponent } from './table.component'
import { TableBodyColumnComponent } from './table-body-column/table-body-column.component'
import { TranslateModule } from '@ngx-translate/core'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'
import { NgClickOutsideDirective } from 'ng-click-outside2'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgSelectModule } from '@ng-select/ng-select'
import { SharedModule } from '@shared/shared.module'

@NgModule({
  declarations: [
    TableComponent,
    TableHeadColumnComponent,
    TableBodyColumnComponent,
  ],
  imports: [
    LottieComponent,
    ReactiveFormsModule,
    CommonModule,
    BrowserAnimationsModule,
    TranslateModule,
    ContentEditableModule,
    NgClickOutsideDirective,
    NgSelectModule,
    FormsModule,
  ],
  providers: [
    provideLottieOptions({
      player: () => player,
    }),
  ],
  exports: [TableComponent, TableHeadColumnComponent, TableBodyColumnComponent],
})
export class TableModule {}
